import { type DateInputProps } from '@mantine/dates';
import { DateInput } from '../../inputs/DateInput';
import { useEditorContext } from '../EditorContext';
import type { LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalDateItemProps<TFormType> extends DateInputProps {
    fieldKey: LooseKeys<TFormType>;
    required?: boolean;
    label?: string;
    labelWidth?: number;
}

export const ModalDateItem = <TFormType,>({
    label,
    fieldKey,
    required,
    labelWidth,
    ...dateInputProps
}: ModalDateItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const error = form.errors[fieldKey];

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <DateInput
                key={form.key(fieldKey)}
                {...form.getInputProps(fieldKey)}
                readOnly={loading}
                required={required}
                error={false}
                {...dateInputProps}
            />
        </ModalEditorItemBase>
    );
};
